import { render, staticRenderFns } from "./my-dialog.vue?vue&type=template&id=ef79b9fa&scoped=true&"
import script from "./my-dialog.vue?vue&type=script&lang=js&"
export * from "./my-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef79b9fa",
  null
  
)

export default component.exports